//POST/api/v1/amount  body={amount}
//GET/api/v1//amount/latest

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export async function setAmount(amount) {
    const response = await fetch(`${API_URL}/api/v1/amount`, {
        method: 'POST',
        headers: getAuthHeader(),
        body: JSON.stringify({ amount })
    });
    return response;
}

export async function getLatestAmount() {
    const response = await fetch(`${API_URL}/api/v1/amount/latest`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}
